
import en_UK from "./en_UK.json";
import { CacheManager } from "../utils/CacheManager";

export type LanguageMap<T> = { [key: string]: T };

export class BaseI18nManager<T> {

    Labels: T;
    activeLanguage: string;
    public static _countryCurrency = [
        {
            currency_sign: "₦",
            country_code: "NGA",
            currency_code: "NGN",
            currency_name: "Naira",
            country_name: "Nigeria",
        },
        {
            currency_sign: "$",
            country_code: "USA",
            currency_code: "USD",
            currency_name: "US Dollar",
            country_name: "United States of America",
        },
    ];

    constructor(languages: LanguageMap<T>) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        this.activeLanguage = (urlSearchParams.get("lang") ?? CacheManager.get("lang") ?? "en_UK");
        this.Labels = languages[this.activeLanguage.replace('-', '_')] || languages["en_UK"];
    }

    queryCountryCurrency(value: string, find: string, ret: string) {
        return (BaseI18nManager._countryCurrency.find((cc: any) => cc[find] === value) as any)?.[ret] ?? value;
    }

}

export type Labels = {

    rivtn: string;
    omnehost: string;
    omnehost_detail: string;
    omnehost_logo_url: string;
    all_right_reserved: string;
    auth: {
        sign_in: string;
        sign_out: string;
        dashboard: string;
        manage_your_teams: string;
        create_tournament: string;
    };
    program: {
        program: string;
        home_label: string;
        copyrights: string;
        leaderboard: string;
        tournaments_label: string;
        home: {
            pool: string;
            payouts: string;
            latest_tournaments: string;
            create_tournaments: string;
            search_tournaments: string;
            stats: {
                active_teams: string;
                total_members: string;
                total_matches: string;
                trophies_issued: string;
                physical_rewards: string;
                total_tournaments: string;
            };
        };
        tournaments: {
            visit: string;
            register: string;
            tournaments_hub: string;
        };
    };
    landing: {
        connect: string;
        navigation: string;
        result_empty: string;
        all_r_reserved: string;
        my_tournaments: string;
        join_tournaments: string;
    };
    gallery: {
        desc: string;
        close: string;
        photo: string;
        gallery: string;
    };
    footer: {
        label: string;
        location: string;
    }[];

}

export const i18nManager = new BaseI18nManager<Labels>({
    en_UK,
});